import { Injectable } from '@angular/core';
import { Ventrncotizacion } from "../veninterfaces/ventrncotizacion";
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
@Injectable({
  providedIn: 'root'
})
export class VentrncotizacionService {
  public trncotiza: Ventrncotizacion[] = [];
  public decimalesCantidad: number;
  public decimalesCosto: number;
  public decimalesTotal: number;
  public decimalesCantEnc: number;
  public decimalesPrecio: number;
  public decimalesTOTALFAC: number;

  public hmpConfiguracion: any[];

  public url: string;
  public way: string;

  constructor(
    private http: HttpClient,
    private confIniciales: ConfInicialesService,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
  ) {
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');
  }

  erBusquedaVendedor(strCampo, strTabla, strValue, strParam) {
    return this.http.post(this.way + '/ventas/facturas/3rw6uc890a4nleo', {
      elementos: {
        CAMPO: strCampo,
        VALOR: strTabla,
        VALUE: strValue,
        PARAM: strParam
      },

    }, this.confIniciales.httpOptions());
  }
  erpBusquedaCliente(strValor, strValue, strParams) {
    return this.http.post(this.way + '/ventas/facturas/tq8cgrtwkhkurwk', {
      elementos: {
        Valor: strValor,
        Value: strValue,
        Params: strParams
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  encontrarGruNombre(strCondicion) {
    return this.http.post(this.way + '/inventario/articulo/3b70dfaf8b2f6e', {
      elementos: {
        condicion: strCondicion
      },
    }, this.confIniciales.httpOptions());
  }
}
